import React, { useEffect, useRef, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import classNames from "classnames";
import StepHeader from "../components/StepHeader";
import VehicleCard from "../components/VehicleCard";
import request from "../../../network/request";
import ReservationItems from "../components/ReservationItems";
import RemarkContent from "../components/RemarkContent";
import StoreAndTimeSelector from "../pickupTimeAndShop/indexV2";
import ContactForm from "../ContactForm";
import ReservingCard from "../components/ReservingCard";
import useBasicFormData from "../store/useBasicFormData";
import useBaseInfo from "../store/useBaseInfo";
import { RESERVE_STEP_INDEX } from "../config/constants";
import useGlobalInitData from "../store/useGlobalInitData";
import useGetCh from "../../../hooks/useGetCh";
import Loading from "../../../components/CommonLoading";
import usePickupAddress from "../store/usePickupAddress";
import { sendReport } from "../../../utils/reporter";
import { getLocationFromApp } from "../common/funcs";

import styles from "./indexV2.module.scss";
import useUserRightRequest from "../store/useUserRightRequest";
import { RESULT_CODE } from "../../../constants";
import SubmitErrorAlert, {
  SubmitErrorAlertRef,
} from "../components/SubmitErrorAlert";
import { findServiceItemsParam } from "../utils";
import CityPicker from "../CityPicker";
import { ReservationItemTypes } from "../interfaces/home";
import { useMount } from "ahooks";
import useReserveStep from "../hooks/useReserveStep";
import useReserveStoreInfo from "../hooks/useReserveStoreInfo";
import useReserveTimeInfo from "../hooks/useReserveTimeInfo";

export default function HomePageV2(props) {
  const ch = useGetCh();
  const history = useHistory();
  const { globalInitData } = useGlobalInitData();
  const { baseInfo } = useBaseInfo();
  const {
    basicFormData,
    resetStoreAndDateData,
    setModifyOrderArriveStoreTime,
    setModifyOrderShopCode,
  } = useBasicFormData();

  const { pickupAddress } = usePickupAddress();
  const { runAsync: getUserRight } = useUserRightRequest();
  const submitLockRef = useRef(false);
  const submitErrorAlertRef = useRef<SubmitErrorAlertRef>(null);
  const [reserveItems, setReserveItems] = useState<ReservationItemTypes[]>([]);
  const [remarkContent, setRemarkContent] = useState("");

  const { currentStep: currentFormStep, canGoNextStep, prev, next }  = useReserveStep({ reserveItems });
  const btnDisabled = !canGoNextStep;
  const reserveStoreInfo = useReserveStoreInfo();
  const reserveTimeInfo = useReserveTimeInfo();

  const canReserve = useMemo(() => !!reserveItems.length, [reserveItems]);

  const setNextStep = () => {
    next(async (_, current) => {
      if (current === RESERVE_STEP_INDEX.TIME_STORE) {
        try {
          // 获取取送车权益信息
          Loading.show();
          await getUserRight({
            vin: baseInfo?.frameNumber,
            preComeDate: reserveTimeInfo
              ? `${reserveTimeInfo.date} ${reserveTimeInfo.startTime}`
              : "",
          });
        } finally {
          Loading.hide();
        }
      }
    });
  };

  const setPreStep = () => prev();

  /**
   * 提交预约单
   */
  const submitReservationHandler = async () => {
    if (btnDisabled || submitLockRef.current) return;
    submitLockRef.current = true;
    let reqData: any = {};

    const { usePickupService, contactName, contactPhone, pickupServiceTime } =
      basicFormData.contactInfoStepData;

    const { serviceItems, repairDescList, eventCode, capacityType } =
      findServiceItemsParam(reserveItems);

    reqData = {
      isDriving: usePickupService ? 1 : 0,
      serviceItems,
      eventCode,
      vin: baseInfo?.frameNumber,
      plateNumber: baseInfo?.plateNumber || baseInfo?.addedPlateNumber,
      reserveTel: contactPhone,
      reserveMan: contactName,
      csDesc: remarkContent,
      capacityType,
      descList: repairDescList, // 勾选的维修描述
      shopUuid: reserveStoreInfo?.uuid,
      shopCode: reserveStoreInfo?.code,
      cityCode: reserveStoreInfo?.cityCode,
      cityName: reserveStoreInfo?.city,
      preComeDate: `${reserveTimeInfo?.date} ${reserveTimeInfo?.startTime}`,
    };

    // 是否使用取送车服务
    if (usePickupService) {
      reqData.cityCode = pickupAddress?.drivingPickupCityCode;
      reqData.cityName = pickupAddress?.drivingPickupCityName;
      reqData.drivingPickupAddressLng = pickupAddress?.drivingPickupAddressLng;
      reqData.drivingPickupAddressLat = pickupAddress?.drivingPickupAddressLat;
      reqData.drivingPickupAddress = pickupAddress?.drivingPickupAddress?.slice(
        0,
        99
      );
      reqData.drivingBookingTime = `${reserveTimeInfo?.date} ${pickupServiceTime}`;
    }

    console.log("before send create reservation Order, paramsssss", reqData);

    sendReport({
      mcode: "提交预约点击",
      point: "P11183`B017",
    });

    try {
      Loading.show("提交中");
      const res: any = await request(
        "/public/v2/module/maintenance/save",
        { ...reqData },
        "POST",
        {
          useCustomUrl: true,
          pureReturn: true,
        }
      );
      console.log("创建预约结果", res);
      const { code, data } = res;
      if (code === 200) {
        console.log(
          ">>>>预约成功 跳转路由>>>>>",
          `/reservation/success/${data.reserveOrderCode}?ch=${ch}&today=${
            data.today ? "1" : "0"
          }&withinWorkHour=${data.withinWorkHour ? "1" : "0"}`
        );
        history.replace(
          `/reservation/success/${data.reserveOrderCode}?ch=${ch}&today=${
            data.today ? "1" : "0"
          }&withinWorkHour=${data.withinWorkHour ? "1" : "0"}`
        );
        sendReport({
          mcode: "预约成功返回量",
          point: "P11188`B002",
        });
      } else {
        console.error("创建预约失败", res);
        if (
          code === RESULT_CODE.GLOBAL_RATE_LIMITING ||
          code === RESULT_CODE.RESERVE_LOCKED
        ) {
          submitErrorAlertRef.current?.open(res.msg || "系统繁忙，请稍后再试");
        } else {
          const isIncludeSpecialType = !!eventCode;
          console.warn(
            ">>>>预约接口报错 跳转路由>>>>>",
            `/reservation/fail?ch=${ch}&errorcode=${res.code}&failtext=${res.msg}` +
              (isIncludeSpecialType ? "&special=1" : "")
          );
          history.push(
            `/reservation/fail?ch=${ch}&errorcode=${res.code}&failtext=${res.msg}` +
              (isIncludeSpecialType ? "&special=1" : "")
          );
        }
        sendReport({
          mcode: "预约失败量",
          point: "P11188`B003",
        });
      }
    } catch (err) {
      sendReport({
        mcode: "预约失败量",
        point: "P11188`B003",
      });
      console.error("创建预约失败", (err as any).message);
      console.warn(
        ">>>>预约失败 跳转路由>>>>>",
        `/reservation/fail?ch=${ch}&failtext=${(err as any).message}`
      );
      history.push(
        `/reservation/fail?ch=${ch}&failtext=${(err as any).message}`
      );
    } finally {
      submitLockRef.current = false;
      Loading.hide();
    }
  };

  const showStepHeader = useMemo(() => {
    return (
      canReserve &&
      // 已有预约时，在第一步也不显示进度条
      !(
        globalInitData.reserveGoingRecordDto.haveReserve &&
        currentFormStep === RESERVE_STEP_INDEX.RESERVE_ITEMS
      )
    );
  }, [
    canReserve,
    globalInitData.reserveGoingRecordDto.haveReserve,
    currentFormStep,
  ]);

  useEffect(() => {
    const canReserveItems =
      basicFormData.reserveItemsStepData.serviceItemState.filter((item) => {
        return globalInitData.reserveGoingRecordDto.canReserveType?.includes(
          item.displayType
        ) || false;
      });
    // 根据后端返回的可预约类型，过滤可以选择的预约项
    setReserveItems(canReserveItems);
  }, [
    basicFormData.reserveItemsStepData.serviceItemState,
    globalInitData.reserveGoingRecordDto.canReserveType,
  ]);

  useMount(() => {
    getLocationFromApp()
    .then((res) => {
      const lngAndLat = {
        longitude: res?.data?.coords?.longitude ?? "",
        latitude: res?.data?.coords?.latitude ?? "",
      };
      console.log("当前经纬度: ", lngAndLat);
      localStorage.setItem("current_lng_and_lat", JSON.stringify(lngAndLat));
    })
    .catch((res) => {
      localStorage.setItem(
        "current_lng_and_lat",
        JSON.stringify({ longitude: "", latitude: "" })
      );
    });

    setModifyOrderArriveStoreTime(0);
    setModifyOrderShopCode("");
  });

  return (
    <div className={styles.homepage}>
      {showStepHeader ? <StepHeader current={currentFormStep} /> : null}
      <>
        {currentFormStep === RESERVE_STEP_INDEX.RESERVE_ITEMS && (
          <>
            <VehicleCard />
            <ReservingCard showHasReserveTip={!canReserve} />
            {canReserve ? (
              <>
                <ReservationItems
                  reserveItems={reserveItems}
                  onChange={(newReserveItems) => {
                    setReserveItems(newReserveItems);
                    resetStoreAndDateData();
                  }}
                />
                <RemarkContent
                  content={remarkContent}
                  onChange={setRemarkContent}
                />
              </>
            ) : null}
          </>
        )}
        {canReserve ? (
          <>
            {currentFormStep === RESERVE_STEP_INDEX.TIME_STORE && (
              <StoreAndTimeSelector reserveItems={reserveItems} />
            )}
            {currentFormStep === RESERVE_STEP_INDEX.CONTACT_INFO && (
              <ContactForm
                reserveItems={reserveItems}
                remarkContent={remarkContent}
              />
            )}

            <div className={styles.bottomActionField}>
              {currentFormStep !== RESERVE_STEP_INDEX.RESERVE_ITEMS && (
                <div className={styles.preStepBtn} onClick={setPreStep}>
                  上一步
                </div>
              )}
              {currentFormStep !== RESERVE_STEP_INDEX.CONTACT_INFO ? (
                <div
                  className={classNames(styles.nextStepBtn, {
                    [styles.mediumBtn]:
                      currentFormStep !== RESERVE_STEP_INDEX.RESERVE_ITEMS,
                    [styles.btnDisabled]: btnDisabled,
                  })}
                  onClick={setNextStep}
                >
                  下一步
                </div>
              ) : (
                <div
                  className={classNames(
                    `${styles.nextStepBtn} ${styles.mediumBtn}`,
                    {
                      [styles.btnDisabled]: btnDisabled,
                    }
                  )}
                  onClick={submitReservationHandler}
                >
                  提交预约
                </div>
              )}
            </div>

            <SubmitErrorAlert ref={submitErrorAlertRef} />
          </>
        ) : null}
      </>
      <CityPicker />
    </div>
  );
}
